import { Center, Flex, HStack, Img, Text, VStack } from "@chakra-ui/react"

const LoginPage = () => {
    const login = () => {
        window.location.href = `https://stonefinityaccounts.z27.web.core.windows.net/login?app_id=MOL20231115`
    }
    return (
        <Flex
            minH={'100vh'}
            align={'center'}
            justify={'center'}>
            <VStack spacing={16} mx={'auto'} maxW={'lg'} py={12} px={6}>
                <Center w={'300px'}>
                    <Img src={'/assets/images/logo.jpg'} w={'full'} />
                </Center>
                <HStack
                    onClick={login}
                    cursor={'pointer'}
                    bg={'blue.500'}
                    _hover={{ bg: 'blue.600' }}
                    justify={'space-between'}
                    p={'8px 12px 8px 8px'}
                    borderRadius={'6px'}>
                    <Img src={'/assets/images/as-logo-white.png'} w={'32px'} />
                    <Text color={'white'} fontWeight={500}>Login with analyticsmart</Text>
                </HStack>
            </VStack>
        </Flex>
    )
}

export default LoginPage